import React from 'react'
import './about.css'
import HeaderAbout from '../../component/headerabout/HeaderAbout'
import headerimage from "../../images/header_bg_1.jpg";
import storyimage from "../../images/about1.jpg"
import visionimage from "../../images/about2.jpg"
import missionimage from "../../images/about3.jpg"



function About() {
  return (
    <>
      <HeaderAbout title="about us" image={headerimage}>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. At ipsam aspernatur sed fugiat natus dolores quibusdam molestias mollitia eaque reprehenderit laudantium, animi maxime velit. Sequi in assumenda vitae corrupti perspiciatis.
      </HeaderAbout>
      <section className='about__story'>
        <div className="container about__story-container">
          <div className="about__image">
            <img src={storyimage} alt="image"  />
          </div>
          <div className="about__section-content">
            <h1>our story</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam possimus praesentium quidem autem quo, cum ducimus ullam est cumque recusandae eveniet, magnam, at voluptatibus. Impedit corporis modi non perspiciatis quaerat!
            </p>
            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corporis reiciendis eius molestias odit maxime eum animi dolor pariatur sit ab. Dolores nesciunt iure reprehenderit autem laudantium nostrum pariatur molestiae doloremque.</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Esse consequuntur voluptas eius nesciunt. Cupiditate deleniti ex assumenda qui molestias dignissimos.</p>
          </div>
        </div>
      </section>

      <section className='about__vision'>
        <div className="container about__vision-container">

        <div className="about__section-content">
            <h1>our vision</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam possimus praesentium quidem autem quo, cum ducimus ullam est cumque recusandae eveniet, magnam, at voluptatibus. Impedit corporis modi non perspiciatis quaerat!
            </p>
            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corporis reiciendis eius molestias odit maxime eum animi dolor pariatur sit ab. Dolores nesciunt iure reprehenderit autem laudantium nostrum pariatur molestiae doloremque.</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Esse consequuntur voluptas eius nesciunt. Cupiditate deleniti ex assumenda qui molestias dignissimos.</p>
          </div>

          <div className="about__image">
            <img src={visionimage} alt="image"  />
          </div>
          
        </div>
      </section>

      <section className='about__mission'>
        <div className="container about__mission-container">
          <div className="about__image">
            <img src={missionimage} alt="image"  />
          </div>
          <div className="about__section-content">
            <h1>our mission</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam possimus praesentium quidem autem quo, cum ducimus ullam est cumque recusandae eveniet, magnam, at voluptatibus. Impedit corporis modi non perspiciatis quaerat!
            </p>
            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corporis reiciendis eius molestias odit maxime eum animi dolor pariatur sit ab. Dolores nesciunt iure reprehenderit autem laudantium nostrum pariatur molestiae doloremque.</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Esse consequuntur voluptas eius nesciunt. Cupiditate deleniti ex assumenda qui molestias dignissimos.</p>
          </div>
        </div>
      </section>
    </>
  )
}

export default About